const ID = 'sidemenu';

export default ID;
